import { useFormContext } from "../FormContext";

/**
 * Custom hook for form state management
 *
 * Provides a clean interface for accessing and updating form data
 * Compatible with existing Apollo-based implementations
 *
 * @returns Object containing form data and update functions
 */
export const useForm = () => {
  const { formData, updateFormData } = useFormContext();

  return {
    formData,
    updateFormData,
  };
};

/**
 * Apollo-compatible reactive form hook
 *
 * Provides backward compatibility with existing Apollo reactive variable patterns
 * Can be used as a drop-in replacement for Apollo useReactiveVar(form)
 *
 * @returns Function that can get/set form data, mimicking Apollo reactive variables
 */
export const useFormReactive = () => {
  const { formData, updateFormData } = useFormContext();

  /**
   * Form reactive function
   *
   * When called without arguments, returns current form data
   * When called with data, updates the form data
   *
   * @param newData - Optional new form data to set
   * @returns Current form data
   */
  const form = (newData?: any) => {
    if (newData) {
      updateFormData(newData);
    }
    return formData;
  };

  return form;
};
